import glassWallPartTypes from 'components/configurator/types/glassWallPartTypes';
import IGlass from 'components/interfaces/IGlass';
import IGlassArea from 'components/interfaces/IGlassArea';
import IWallMetaData from 'components/interfaces/IWallMetaData';
import { MANUAL } from 'services/constants/glassWidthCalculationTypes';

import getDefaultGlass from './getDefaultGlass';
import getDefaultGlassArea from './getDefaultGlassArea';

const getGlassAreaName = (glassArea: any) => {
  if (glassArea.areaName != null) {
    return glassArea.areaName;
  }

  if (glassArea.glassIds === undefined) {
    return '';
  }

  if (glassArea.glassIds.length === 0) {
    return '';
  }

  const wallComponentFirstGlassId = glassArea.glassIds[0];

  const nameParts = wallComponentFirstGlassId.split(' / ');

  if (nameParts.length < 2) {
    return '';
  }

  nameParts.pop();

  return nameParts.join(' ');
};

const loadGlassAreas = (
  rawSelectedWall: any,
  wallMetaData: IWallMetaData
): IGlassArea[] => {
  if (rawSelectedWall === undefined) {
    return [getDefaultGlassArea()];
  }

  if (rawSelectedWall.wallComponents === undefined) {
    return [getDefaultGlassArea()];
  }

  const rawGlasses = rawSelectedWall.wallComponents.filter(
    (wallComponent: any): wallComponent is IGlassArea =>
      wallComponent.type === glassWallPartTypes.glass
  );

  const getGlasses = (index: number): IGlass[] => {
    if (wallMetaData.glassAreas[index] === undefined) {
      return [{ width: 0 }];
    }

    if (wallMetaData.glassAreas[index].calculationType === MANUAL) {
      return rawGlasses[index].glassWidths.map((width: number) => ({
        width,
      }));
    }

    return [getDefaultGlass()];
  };

  return rawGlasses.map((glassArea: IGlassArea, index: number) => ({
    ...getDefaultGlassArea(),
    name: getGlassAreaName(glassArea),
    glasses: getGlasses(index),
  }));
};

export default loadGlassAreas;
